import request from '@/utils/request';

export function getRoomToken(query:any) {
  return request({
    url: '/Rtc/requestRtc',
    method: 'get',
    params: query
  });
}

export function acceptanceRtc(query:any) {
  return request({
    url: '/Rtc/acceptanceRtc',
    method: 'get',
    params: query
  });
}

export function enterRoom(query:any) {
  return request({
    url: '/Rtc/enterRoom',
    method: 'post',
    data: query
  });
}

export function leaveRoom(query:any) {
  return request({
    url: '/Rtc/leaveRoom',
    method: 'post',
    data: query
  });
}
